<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button  (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Select a Service</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <smr-stylist-picker 
    [stylistID]="stylist.getID()"
    [readOnly]="readOnlyStylistPicker"
    (onInit)="onStylistPickerInit($event)"
    (stylistSelect)="onStylistSelect($event)"
  ></smr-stylist-picker>
  
  <smr-service-definition-list
    [serviceCategories]="serviceCategories"
    (serviceDefinitionSelect)="onServiceDefinitionSelect($event)"
    >
  </smr-service-definition-list>
  
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingProducts || errorOccurredWhileLoadingStylistPicker" (click)="onTapToReload()"></salonmonster-tap-retry>
</ion-content>
